// export const isDevelopment = () =>
//   !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const BASE_URL = 'https://gateway.tangerineglobal.com/';
export const AUTH_URL = BASE_URL + 'auth' + getBaseUrl(true);

export const BASE_URL_MAP: Record<OperatorType, string> = {
  Hospitality: BASE_URL + 'hos' + getBaseUrl(false),
  Residential: BASE_URL + 'res' + getBaseUrl(false),
};

export const isDevelopment = () => {
  let origin = window.location.origin;
  if (!origin) {
    origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }
  return /local/.test(origin) || /dev/.test(origin);
};

export function getBaseUrl(isAuth: boolean) {
  let origin = window.location.origin;
  if (!origin) {
    origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }

  if (/local/.test(origin) || /dev/.test(origin)) {
    return 'dev';
  } else if (/staging/.test(origin) && !isAuth) {
    return 'stage';
  }

  return '';
}
